import { useForm } from "react-hook-form";
import "./FormSummary.scss";
import ControlInputBoxVoting from "./Components/ControlInputBoxVoting";
import {
  FORM_ACTION_TYPE,
  FORM_DESCRIPTION_FRENCH_ID,
  FORM_DUE_DATE,
  FORM_ID,
  FORM_ID_DESCRIPTION,
  FORM_ID_FRENCH,
  FORM_IS_REVIEW,
  FORM_IS_SIGNATURE,
  FORM_PAST_DUE_DATE,
  FORM_PUBLISH_LOGIC,
  FORM_STAGE,
  FORM_STATUS,
  FORM_TYPE,
} from "./Constant";
import ControlTextAreaWithCharLimit from "@/components/Form/InputBox/ControlTextAreaWithCharLimit";
import ControlSelect from "../../Claim/ClaimDetails/ControlSelect";
import ControlCheckBox from "./ControlCheckBox";
import { useEffect, useMemo, useState } from "react";
import { FormSummaryEditFormType } from "./type";
import Button from "@/components/Form/Button/Button";
import FormattedDatePicker from "@/components/FormattedDatePicker/FormattedDatePicker";
import { useLazyGetStagesQuery } from "@/services/stages/stagesReducer";
import { useNavigate, useParams } from "react-router-dom";
import { useCase } from "@/features/case/use-case";
import {
  useCreateClaimFormMutation,
  useGetReadCustomFormApiQuery,
  useUpdateClaimFormMutation,
} from "./PortalConfigReducer";
import TimeInputField from "./Components/TimeImput";
import { MotifErrorMessage, MotifProgressLoader } from "@ey-xd/motif-react";
import { useDispatch } from "react-redux";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { useTranslation } from "react-i18next";
import { CANCEL_BUTTON_VARIANT, SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import NotificationGrid from "@/components/Notification/NotificationGrid";
import { ActiveTabsOrder } from "@/menuData";
export interface formData {
  editView: boolean;
}

interface formDataProps {

  formData: formData;
}
type ActionTypeOption = {
  label: string;
  value: string;
};
type PublishLogicOption = {
  label: string;
  value: string;
};


const FormManagementSummary = ({ formData }: formDataProps) => {
  const { editId } = useParams<{ editId: string }>();
  const { t } = useTranslation();

  const Action_Type: ActionTypeOption[] = useMemo(() => [
    { label: t("pages.portalConfiguration.actionTypeLabels.label1"), value: "" },
    { label: t("pages.portalConfiguration.actionTypeLabels.label2"), value: "0" },
    { label: t("pages.portalConfiguration.actionTypeLabels.label3"), value: "1" },
    { label: t("pages.portalConfiguration.actionTypeLabels.label4"), value: "2" },
  ], [t]);
  const Action_Type1: ActionTypeOption[] = useMemo(() => [
    { label: t("pages.portalConfiguration.defaultOptionType"), value: "" },
  ], [t]);
  const Publich_LOGIC: PublishLogicOption[] = useMemo(() => [
    { label: t("pages.portalConfiguration.publishLabels.label1"), value: "" },
    { label: t("pages.portalConfiguration.publishLabels.label2"), value: "0" },
    {
      label: t("pages.portalConfiguration.publishLabels.label3"),
      value: "1",
    },
  ], [t]);
  const PUBLISH_LOGIC1: PublishLogicOption[] = useMemo(() => [
    { label: t("pages.portalConfiguration.defaultOptionType"), value: "" },
  ], [t]);
  const { data: formDataReport } = useGetReadCustomFormApiQuery(editId, {
    refetchOnMountOrArgChange: true,
    skip: !editId,
  });
  const navigate = useNavigate();
  const editView = formData?.editView ? true : false;
  const [isReviewSelected, setReviewSelected] = useState(false);
  const [isSignatureSelected, setIsSignatureSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [ActionType, setActionType] = useState<ActionTypeOption[]>([]);
  const [PublishType, setPublishType] = useState<PublishLogicOption[]>([]);
  const [isshowPublish, setIsShowPublish] = useState(false);
  const [formType, setFormType] = useState("");
  const [showMessage, setShowMessage] = useState({
    show: false,
    type: "error",
    message: "",
  });
  const [dueDate, setDueDate] = useState<Date | undefined>(undefined);

  const Time = new Date("0000-00-00T00:00:00.000Z");
  const [currentStageOptions, setCurrentStageOptions] = useState<
    FormSummaryEditFormType[]
  >([]);

  const caseData = useCase();

  const { caseId } = caseData;
  const defaultOption = { label: t("pages.portalConfiguration.defaultOptionType"), value: "" };

  const {
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    getValues,
    formState: { errors, isDirty },
  } = useForm<FormSummaryEditFormType>(
    {
      defaultValues: {
        name: "",
        description: "",
        nameFrench: "",
        descriptionFrench: "",
        type: "",
        actionSubType: "",
        status: "0",
        publishedDate: "",
        dueDate: "",
        stage: "",
        pastDueAction: "",
        isReview: false,
        isSignature: false,
        publishingLogic: ""
      }
    }
  );
  const [CreateClaim, { isLoading: createLoading }] = useCreateClaimFormMutation();
  const [UpdateClaim, { isLoading: updateLoading }] = useUpdateClaimFormMutation();

  const onSubmit = async (data: FormSummaryEditFormType) => {
    const ClaimApiParam = editView
      ? {
        caseId: caseId,
        id: editId,
        name: data?.name,
        description: data?.description || "",
        nameFrench: data?.nameFrench,
        descriptionFrench: data?.descriptionFrench || "",
        type: parseInt(data?.type, 10),
        actionSubType: parseInt(data?.actionSubType, 10),
        status: parseInt(data?.status, 10),
        dueDate: dueDate,
        stage: data?.stage,
        pastDueAction: parseInt(data?.pastDueAction, 10),
        isReview: data?.isReview,
        isSignature: data?.isSignature,
        publishingLogic: parseInt(data?.publishingLogic, 10) || 0,
      }
      : {
        caseId: caseId,
        name: data?.name,
        description: data?.description || "",
        nameFrench: data?.nameFrench,
        descriptionFrench: data?.descriptionFrench || "",
        type: parseInt(data?.type, 10),
        actionSubType: parseInt(data?.actionSubType, 10),
        status: parseInt(data?.status, 10),
        dueDate: dueDate,
        stage: data?.stage,
        pastDueAction: parseInt(data?.pastDueAction, 10),
        isReview: data?.isReview,
        isSignature: data?.isSignature,
      };
    dispatch(setDiscardEditMode({ editMode: false }));

    if (editView) {
      const responseApi = await UpdateClaim(ClaimApiParam);
      //@ts-ignore
      if (responseApi.data) {
        navigate(caseId ? `/case/${caseId}/form/edit/` + editId : "/", {
          state: {
            showMessage: true,
            defaultActiveKey: 1,
          },
        });
        reset(getValues(), { keepDirty: false });
        setIsLoading(false);

      } else {
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          //@ts-ignore
          message: responseApi.error.message,
        });
        setIsLoading(false);
        dispatch(setDiscardEditMode({ editMode: true }));

      }
    } else {
      try {
        const responseApi = await CreateClaim(ClaimApiParam).unwrap();
        if (responseApi && responseApi.customFormId) {
          navigate(
            caseId
              ? `/case/${caseId}/form/edit/` + responseApi.customFormId
              : "/",
            {
              state: {
                showMessage: true,
                defaultActiveKey: 1,
              },
            }
          );
          setIsLoading(false);
        }
        else {
          setShowMessage({
            ...showMessage,
            show: true,
            type: "error",
            //@ts-ignore
            message: responseApi.error?.message || t("global.globalNotifications.unExpectedError"),
          });
          setIsLoading(false);
          dispatch(setDiscardEditMode({ editMode: true }));
        }
      } catch (error: any) {
        setShowMessage({
          ...showMessage,
          show: true,
          type: "error",
          message: error?.message || t("global.globalNotifications.unExpectedError"),
        });
        setIsLoading(false);
        dispatch(setDiscardEditMode({ editMode: false }));

      }
    }
  };
  const checkBoxHandler = (e?: React.ReactEventHandler) => {
    setReviewSelected(!isReviewSelected);
  };
  const checkBoxsingnatureHandler = (e?: React.ReactEventHandler) => {
    setIsSignatureSelected(!isSignatureSelected);
  };
  const [getStagesQuery] = useLazyGetStagesQuery();

  const STAGE_OPTIONS: any[] = currentStageOptions
    ? currentStageOptions.map((item: any) => {
      return {
        label: item?.name || "",
        value: item?.id || "",
      };
    })
    : [];
  const StageOptions = [defaultOption, ...STAGE_OPTIONS];
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setDiscardEditMode({ editMode: isDirty }));
    return () => {
      dispatch(setDiscardEditMode({ editMode: false }));
    };
  }, [dispatch, isDirty]);

  useEffect(() => {
    if (caseId) {
      getStagesQuery(caseId).then((response) => {
        if (response?.data?.length > 0) {
          setCurrentStageOptions(response.data);
        }
      });
    }
    // eslint-disable-next-line
  }, [caseId, getStagesQuery]);

  const Type = watch(FORM_TYPE);
  useEffect(() => {
    if (Type === "1") {
      setActionType(Action_Type);
      setFormType(Type);
    } else if (Type === "0" || Type === "2") {
      setFormType(Type);
      setActionType(Action_Type1);
      setValue("actionSubType", "");
    }
    else {
      setFormType("");
    }
  }, [Type, setValue, Action_Type, Action_Type1]);
  const PublishLogic = watch(FORM_STATUS);
  useEffect(() => {
    if (PublishLogic === "1" || PublishLogic === "2") {
      setPublishType(Publich_LOGIC);
      setIsShowPublish(true);
    } else if (PublishLogic === "0" || PublishLogic === "3") {
      setPublishType(PUBLISH_LOGIC1);
      setIsShowPublish(false);
      setValue("publishingLogic", "");
    }
  }, [PublishLogic, setValue, Publich_LOGIC, PUBLISH_LOGIC1]);
  useEffect(() => {
    if (editView && formDataReport) {
      if (currentStageOptions.length > 0) {
        reset({
          name: formDataReport?.name,
          nameFrench: formDataReport?.nameFrench,
          description: formDataReport?.description,
          descriptionFrench: formDataReport?.descriptionFrench,

          type:
            formDataReport?.type === "Action Form"
              ? "1"
              : formDataReport?.type === "Claim Form"
              ? "0"
              : formDataReport?.type === "Other Form"
              ? "2"
              : "",
          pastDueAction:
            formDataReport?.pastDueAction ===
            "Hide form, but allow in-progress submissions"
              ? "0"
              : formDataReport?.pastDueAction ===
                "Hide form, no submissions allowed"
              ? "1"
              : formDataReport?.pastDueAction ===
                "Warn portal users on deadline only"
              ? "2"
              : "",
          actionSubType:
            formDataReport?.actionSubType === "Amend Form"
              ? "0"
              : formDataReport?.actionSubType === "Dispute Form"
              ? "1"
              : formDataReport?.actionSubType === "Withdraw Form"
              ? "2"
              : "",

          status:
            formDataReport?.status === "Draft"
              ? "0"
              : formDataReport?.status === "Published for testing"
              ? "1"
              : formDataReport?.status === "Publish"
              ? "2"
              : formDataReport?.status === "Hidden"
              ? "3"
              : "",
          publishedDate: formDataReport?.publishedDate,
          dueDate: formDataReport?.dueDate,
          stage: formDataReport?.stage || "",
          isReview: formDataReport?.isReview,
          isSignature: formDataReport?.isSignature,
          publishingLogic:
            formDataReport?.publishingLogic ===
            "Previous in-progress forms will not be invalidated"
              ? "0"
              : formDataReport?.publishingLogic ===
                "Invalidate all in-progress forms and replace with new version"
              ? "1"
              : "",
        });

        const dueDateString = formDataReport?.dueDate;
        if (dueDateString) {
          const parsedDate = new Date(dueDateString);
          setDueDate(parsedDate);
        }
      }
    }
  }, [formDataReport, editView, reset, currentStageOptions]);


  if (editView && !currentStageOptions) {
    return <MotifProgressLoader />;
  }

  return (
    <>
      <div className="motif-container case-summary-form pad-v-20">
        <div className="motif-row justify-content-between align-items-center">
          <div className="motif-col-4">
            <div className="motif-body1-default-regular page-title">
              {t("pages.portalConfiguration.createFormSubTitle")}
            </div>
            <div className="motif-body2-default-regular page-description">
              {t("pages.portalConfiguration.createFormSubDescription")}
            </div>
          </div>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="mar-b-80">
        <div
          className={`motif-container main-container creditor-summary-view${!editView ? "create" : ""
            }`}
        >
          {
            showMessage.show && showMessage.type === "error" && (
              <NotificationGrid
                show={showMessage.show}
                message={showMessage.message}
                type={showMessage.type}
              />
            )
          }
          <div className="motif-row heights">
            <div className="motif-col-md-3">
              <div className="form-field">
                <ControlInputBoxVoting
                  control={control}
                  required={true}
                  isTextArea={false}
                  label={"pages.portalConfiguration.formLabels.formName"}
                  showLabel={true}
                  readonly={false}
                  name={FORM_ID}
                />
                {errors[FORM_ID] && errors[FORM_ID].type === "required" && (
                  <MotifErrorMessage>
                    {t(
                      "pages.portalConfiguration.validationMessages.formNameReq"
                    )}
                  </MotifErrorMessage>
                )}
              </div>
            </div>
            <div className="motif-col-md-3">
              <div className="form-field">
                <ControlInputBoxVoting
                  control={control}
                  required={false}
                  isTextArea={false}
                  label={"pages.portalConfiguration.formLabels.formNameFrench"}
                  showLabel={true}
                  readonly={false}
                  name={FORM_ID_FRENCH}
                />
              </div>
            </div>
          </div>
          <div
            className="motif-row next-row heights
          "
          >
            <div className="motif-col-md-3">
              <div className="form-field">
                <ControlTextAreaWithCharLimit
                  name={FORM_ID_DESCRIPTION}
                  control={control}
                  required={false}
                  isTextArea={true}
                  label={"pages.portalConfiguration.formLabels.formDescription"}
                  showLabel={true}
                  readonly={false}
                />
              </div>
            </div>
            <div className="motif-col-md-3">
              <div className="form-field">
                <ControlTextAreaWithCharLimit
                  name={FORM_DESCRIPTION_FRENCH_ID}
                  control={control}
                  required={false}
                  isTextArea={true}
                  label={
                    "pages.portalConfiguration.formLabels.formDescriptionFrench"
                  }
                  showLabel={true}
                  readonly={false}
                />
              </div>
            </div>
          </div>
          <div className="motif-row heights">
            <div className="motif-col-lg-3">
              <div className="form-field">
                {editView && (
                  <ControlSelect
                    name={FORM_TYPE}
                    //@ts-ignore
                    control={control}
                    required={true}
                    showLabel={true}
                    disabled={true}
                    label={"pages.portalConfiguration.formLabels.formType"}
                    placeholder={"placeholder"}
                    options={[
                      {
                        label: t(
                          "pages.portalConfiguration.formTypeLabels.label1"
                        ),
                        value: "",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formTypeLabels.label2"
                        ),
                        value: "0",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formTypeLabels.label3"
                        ),
                        value: "1",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formTypeLabels.label4"
                        ),
                        value: "2",
                      },
                    ]}
                  />
                )}
                {!editView && (
                  <ControlSelect
                    name={FORM_TYPE}
                    //@ts-ignore
                    control={control}
                    required={true}
                    showLabel={true}
                    disabled={false}
                    label={"pages.portalConfiguration.formLabels.formType"}
                    placeholder={"placeholder"}
                    options={[
                      {
                        label: t(
                          "pages.portalConfiguration.formTypeLabels.label1"
                        ),
                        value: "",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formTypeLabels.label2"
                        ),
                        value: "0",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formTypeLabels.label3"
                        ),
                        value: "1",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formTypeLabels.label4"
                        ),
                        value: "2",
                      },
                    ]}
                  />
                )}
                {errors[FORM_TYPE] && errors[FORM_TYPE].type === "required" && (
                  <MotifErrorMessage>
                    {t("pages.portalConfiguration.validationMessages.formType")}
                  </MotifErrorMessage>
                )}
              </div>
            </div>
            {formType === "1" && (
              <div className="motif-col-lg-3">
                <div className="form-field">
                  {editView && (
                    <ControlSelect
                      name={FORM_ACTION_TYPE}
                      //@ts-ignore
                      control={control}
                      required={false}
                      showLabel={true}
                      disabled={true}
                      label={
                        "pages.portalConfiguration.formLabels.formActionType"
                      }
                      placeholder={"placeholder"}
                      options={ActionType}
                    />
                  )}
                  {!editView && (
                    <ControlSelect
                      name={FORM_ACTION_TYPE}
                      //@ts-ignore
                      control={control}
                      required={false}
                      showLabel={true}
                      disabled={false}
                      label={
                        "pages.portalConfiguration.formLabels.formActionType"
                      }
                      placeholder={"placeholder"}
                      options={ActionType}
                    />
                  )}
                </div>
              </div>
            )}
            <div className="motif-col-lg-3">
              <div className="form-field">
                <ControlSelect
                  name={FORM_STAGE}
                  //@ts-ignore
                  control={control}
                  required={true}
                  showLabel={true}
                  readonly={false}
                  label={"pages.portalConfiguration.formLabels.formStage"}
                  placeholder={"placeholder"}
                  options={StageOptions}
                />
                {errors[FORM_STAGE] &&
                  errors[FORM_STAGE].type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.portalConfiguration.validationMessages.stageReq"
                      )}
                    </MotifErrorMessage>
                  )}
              </div>
            </div>
          </div>
          <div className="motif-row heights">
            <div className="motif-col-md-2">
              <div className="form-field">
                <div className="hidedatepicker">
                  <ControlInputBoxVoting
                    name={FORM_DUE_DATE}
                    control={control}
                    required={false}
                    isTextArea={false}
                    label={"pages.portalConfiguration.formLabels.formDueDate"}
                    showLabel={true}
                  />
                </div>
                <FormattedDatePicker
                  todayMark={true}
                  //@ts-ignore
                  value={dueDate}
                  onChange={(value: any) => {
                    setDueDate(value);
                  }}
                />
              </div>
            </div>
            <div className="motif-col-1">
              <div className="form-field">
                <TimeInputField
                  id="my-time-input"
                  value={Time}
                  required={true}
                  onChange={function (date: Date): void {
                    throw new Error("Function not implemented.");
                  }}
                />
              </div>
            </div>
          </div>

          <div className="motif-row heights">
            {dueDate && (
              <div className="motif-col-lg-3">
                <div className="form-field">
                  <ControlSelect
                    name={FORM_PAST_DUE_DATE}
                    //@ts-ignore
                    control={control}
                    required={true}
                    showLabel={true}
                    readonly={false}
                    label={"pages.portalConfiguration.formLabels.dueSubmission"}
                    placeholder={"placeholder"}
                    options={[
                      {
                        label: t(
                          "pages.portalConfiguration.pastSubmissinLabels.label"
                        ),
                        value: "",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.pastSubmissinLabels.label1"
                        ),
                        value: "0",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.pastSubmissinLabels.label2"
                        ),
                        value: "1",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.pastSubmissinLabels.label3"
                        ),
                        value: "2",
                      },
                    ]}
                  />
                  {errors[FORM_PAST_DUE_DATE] &&
                    errors[FORM_PAST_DUE_DATE].type === "required" && (
                      <MotifErrorMessage>
                        {t(
                          "pages.portalConfiguration.validationMessages.dueSubmissionReq"
                        )}
                      </MotifErrorMessage>
                    )}
                </div>
              </div>
            )}
            <div className="motif-col-lg-3">
              <div className="form-field">
                {editView && (
                  <ControlSelect
                    name={FORM_STATUS}
                    //@ts-ignore
                    control={control}
                    required={true}
                    showLabel={true}
                    disabled={false}
                    label={"pages.portalConfiguration.formLabels.formStatus"}
                    placeholder={"placeholder"}
                    options={[
                      {
                        label: t(
                          "pages.portalConfiguration.formStatusLabels.label1"
                        ),
                        value: "0",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formStatusLabels.label2"
                        ),
                        value: "1",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formStatusLabels.label3"
                        ),
                        value: "2",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formStatusLabels.label4"
                        ),
                        value: "3",
                      },
                    ]}
                  />
                )}
                {!editView && (
                  <ControlSelect
                    name={FORM_STATUS}
                    //@ts-ignore
                    control={control}
                    required={true}
                    showLabel={true}
                    disabled={true}
                    label={"pages.portalConfiguration.formLabels.formStatus"}
                    placeholder={"placeholder"}
                    options={[
                      {
                        label: t(
                          "pages.portalConfiguration.formStatusLabels.label1"
                        ),
                        value: "0",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formStatusLabels.label2"
                        ),
                        value: "1",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formStatusLabels.label3"
                        ),
                        value: "2",
                      },
                      {
                        label: t(
                          "pages.portalConfiguration.formStatusLabels.label4"
                        ),
                        value: "3",
                      },
                    ]}
                  />
                )}
                {errors[FORM_STATUS] &&
                  errors[FORM_STATUS].type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.portalConfiguration.validationMessages.formStatusReq"
                      )}
                    </MotifErrorMessage>
                  )}
              </div>
            </div>
            <div className="motif-col-lg-3">
              <div className="form-field">
                {editView && isshowPublish && (
                  <ControlSelect
                    name={FORM_PUBLISH_LOGIC}
                    //@ts-ignore
                    control={control}
                    required={false}
                    showLabel={true}
                    disabled={false}
                    label={"pages.portalConfiguration.formLabels.formPublish"}
                    placeholder={"placeholder"}
                    options={PublishType}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="motif-row heights">
            <div className="motif-col-md-3">
              <div className="form-field">
                <span>
                  <ControlCheckBox
                    id="checkbox-french-selection"
                    onChange={checkBoxHandler}
                    checked={isReviewSelected}
                    value={isReviewSelected}
                    name={FORM_IS_REVIEW}
                    control={control}
                    required={false}
                    disabled={false}
                    label={t("pages.portalConfiguration.formLabels.formReview")}
                    setIsFrenchSelected={setReviewSelected}
                  />
                </span>
              </div>
            </div>
          </div>
          <div className="motif-row heights">
            <div className="motif-col-md-3 mar-b-20">
              <div className="form-field">
                <span>
                  <ControlCheckBox
                    id="checkbox-french-selection"
                    onChange={checkBoxsingnatureHandler}
                    checked={isSignatureSelected}
                    value={isSignatureSelected}
                    name={FORM_IS_SIGNATURE}
                    control={control}
                    required={false}
                    disabled={false}
                    label={t(
                      "pages.portalConfiguration.formLabels.requestUser"
                    )}
                    setIsFrenchSelected={setIsSignatureSelected}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="button-container sticky-footer">
          <Button
            label={t("global.globalActions.save")}
            type={isLoading ? "loader" : "submit"}
            disabled={false}
            variant={SAVE_BUTTON_VARIANT}
            loading={createLoading || updateLoading}
          />
          <Button
            type="button"
            label={t("global.globalActions.cancel")}
            variant={CANCEL_BUTTON_VARIANT}
            className="cancelBtn"
            disabled={false}
            onClickHandler={() => {
              navigate(`/case/${caseData.caseId}?activeTab=${ActiveTabsOrder.PORTAL}`);
            }}
          />
        </div>
        <br></br>
      </form>
    </>
  );
};
export default FormManagementSummary;
